import { DEFAULT_RIBBON_HALFTONE_MATERIAL, SUBTLE_RIBBON_INTERACTION } from "../interaction";
import { LANDING_ENDCAP_ZOOM, LANDING_HERO_ZOOM, LANDING_MOBILE_HERO_ZOOM, LANDING_MOBILE_LINE_EXTENT, LANDING_VERTICAL_WIDTH_SCALE, LINE_SPACING, MATCHED_IDLE_SPEED, PAPER, PREVIOUS_BLOCK_TOP, REVEAL_SPACING, } from "./shared";
/** Product (prototype LEAHI_AURORA_CONFIG): a bent vertical that straightens. */
export const PRODUCT_PRESET = {
    id: "product",
    roles: ["settle"],
    mobileBreakpoint: 900,
    palette: "primary-v2",
    shape: "line",
    halftone: DEFAULT_RIBBON_HALFTONE_MATERIAL,
    interaction: SUBTLE_RIBBON_INTERACTION,
    curveProfile: {
        viewportSpan: 0.44,
        xCheckpoints: [0.41, 0.66, 0.54],
        bendWindows: [0.1, 0.38, 0.64, 0.9],
        mobile: { viewportSpan: 0.32, xCheckpoints: [0.42, 0.63, 0.53] },
    },
    initialStateId: "leahi-hero",
    states: [
        {
            id: "leahi-hero",
            background: PAPER,
            zoom: LANDING_HERO_ZOOM,
            ribbonWidthScale: LANDING_VERTICAL_WIDTH_SCALE,
            halftoneApparentZoom: LANDING_ENDCAP_ZOOM,
            center: [0.52, 0.5],
            rotationDeg: -84,
            lineExtent: 0.452,
            turbulence: 0.24,
            spacing: REVEAL_SPACING,
            speed: MATCHED_IDLE_SPEED,
            dither: 1,
            spatialColor: 0.1,
            twistRetention: 0.94,
            fanSpread: 0.011,
            twistSpread: 0.023,
            horizontalStretch: 1.18,
            unravel: 0.34,
            curveStrength: 0.44,
            curveProgress: 0.14,
            mobile: {
                zoom: LANDING_MOBILE_HERO_ZOOM,
                center: [0.52, 0.5],
                rotationDeg: -85,
                lineExtent: LANDING_MOBILE_LINE_EXTENT,
                fanSpread: 0.007,
                twistSpread: 0.014,
                horizontalStretch: 1.1,
                curveStrength: 0.34,
            },
        },
        {
            id: "leahi-product",
            background: PAPER,
            zoom: 0.78,
            ribbonWidthScale: LANDING_VERTICAL_WIDTH_SCALE,
            halftoneApparentZoom: LANDING_ENDCAP_ZOOM,
            center: [0.52, 0.5],
            rotationDeg: -88,
            lineExtent: 0.48,
            turbulence: 0.12,
            spacing: LINE_SPACING,
            speed: MATCHED_IDLE_SPEED,
            dither: 1,
            spatialColor: 0.04,
            twistRetention: 0.98,
            fanSpread: 0.004,
            twistSpread: 0.008,
            horizontalStretch: 1.04,
            unravel: 0.12,
            curveStrength: 0.1,
            curveProgress: 0.52,
            mobile: {
                zoom: 0.41,
                center: [0.52, 0.5],
                rotationDeg: -88,
                lineExtent: 0.68,
                curveStrength: 0.08,
            },
        },
    ],
    steps: [
        {
            role: "settle",
            stateId: "leahi-product",
            start: PREVIOUS_BLOCK_TOP,
            end: { target: "top", viewport: 0.25 },
        },
    ],
};
//# sourceMappingURL=product.js.map